<template>
	<div class="bx-page welcome">

		<div class="centered" style="max-width:400px;">
			<h1>Hey {{ user.first_name }} 😊</h1>

			<div v-if="user.is_super">
				🚀 You are a super user. <a href="/a">Access Superuser panel</a>
			</div>

			<h2>Where do you want to go?</h2>


			<template v-if="accounts_loading">

				<ul class="UserAccountSelect" >
					<li v-for="i in 5" :key="i" >
						<span class="loading_string"></span>
					</li>
				</ul>

			</template>
			<template v-else >

				<div v-if="!accounts_loaded">
					There was an error retrieving your accounts. Try reloading.
				</div>

				<ul class="UserAccountSelect" v-if="accounts.length">
					<li v-for="(account, index) in accounts" :key="account.id" >
						<a :href="account.portal_url" :data-cy="`account-${index + 1}`">{{ account.name }}</a>
					</li>
				</ul>

				<div v-else >
					You don't currently have access to any accounts
				</div>

			</template>


		</div>

	</div>
</template>

<style lang="scss" scoped>

	.UserAccountSelect{
		background:#FFF;
		border:1px solid #CCC;
		overflow:hidden;
		border-radius:5px;
		margin:15px 0;

		&,li{
			padding:0;
			list-style:none;
		}

		li{
			margin:0;
			span,a{
				display:block;
				padding:20px 15px;
			}
			a{
				text-decoration:none;
				&:hover{
					background:#fafafa;
				}
			}
		}

	}
</style>

<script>
	import axios from 'axios';

	import {ref,unref} from 'vue';

	import TableView from "../../components/TableView";
	import useAuthStore from "../../stores/AuthStore";

	export default {

		components:{
			TableView,
		},

		setup() {
			var {user} = useAuthStore();

			var accounts = ref([]);
			var accounts_loaded = ref(false);
			var accounts_loading = ref(false);

			return {
				user,
				accounts,
				accounts_loaded,
				accounts_loading
			};
		},

		async beforeRouteEnter(to,from,next){
			var {user} = useAuthStore();
			if( unref(user).accounts.length == 1){
                window.location = unref(user).accounts[0].portal_url;
                next(false);
            }
            next();
		},

		beforeMount(){
			this.getAccounts();
		},


		methods:{
			getAccounts(){
				this.accounts_loading = true;
				axios.get('accounts?user_id='+this.user.id).then(({data})=>{
					this.accounts = data.data;
					this.accounts_loaded = true;
				}).catch(()=>{}).then(()=>{
					this.accounts_loading = false;
				})
			}
		}

	}
</script>
